import {
  Palmtree,
  Stethoscope,
  TriangleAlert,
  BanknoteX,
  BanknoteArrowUp,
  House,
  AlarmClock,
  File,
  Cross,
  CircleX,
  Clock,
  Calendar,
  Briefcase,
  Plane,
  Sun,
  Thermometer,
  Cpu,
  Flame,
  Coffee,
  Music,
  Trophy,
  LayoutDashboard,
  Leaf,
  Map,
  Heart,
  Camera,
  Handshake,
  HandFist,
  Ban,
  Baby,
  Wallet,
  BusFront,
  Ambulance,
  ReceiptText,
  Shapes,
  type LucideIcon,
} from "lucide-react";

// ─── Icon options ─────────────────────────────────────────────────────────────
export const ICON_OPTIONS: { name: string; component: React.ElementType }[] = [
  { name: "Palmtree", component: Palmtree },
  { name: "Baby", component: Baby },
  { name: "Stethoscope", component: Stethoscope },
  { name: "TriangleAlert", component: TriangleAlert },
  { name: "Banknote-x", component: BanknoteX },
  { name: "BanknoteArrowUp", component: BanknoteArrowUp },
  { name: "House", component: House },
  { name: "AlarmClock", component: AlarmClock },
  { name: "Wallet", component: Wallet },
  { name: "File", component: File },
  { name: "Cross", component: Cross },
  { name: "CircleX", component: CircleX },
  { name: "Clock", component: Clock },
  { name: "Calendar", component: Calendar },
  { name: "Briefcase", component: Briefcase },
  { name: "Plane", component: Plane },
  { name: "Sun", component: Sun },
  { name: "Thermometer", component: Thermometer },
  { name: "Cpu", component: Cpu },
  { name: "BusFront", component: BusFront },
  { name: "Ambulance", component: Ambulance },
  { name: "Flame", component: Flame },
  { name: "Coffee", component: Coffee },
  { name: "Music", component: Music },
  { name: "Trophy", component: Trophy },
  { name: "ReceiptText", component: ReceiptText },
  { name: "LayoutDashboard", component: LayoutDashboard },
  { name: "Shapes", component: Shapes },
  { name: "Leaf", component: Leaf },
  { name: "Map", component: Map },
  { name: "Heart", component: Heart },
  { name: "Camera", component: Camera },
  { name: "Handshake", component: Handshake },
  { name: "HandFist", component: HandFist },
  { name: "Ban", component: Ban },
];

// ─── Preset colors (stored as RGB) ───────────────────────────────────────────
export const ICON_MAP: Record<string, LucideIcon> = {
  Palmtree,
  Baby,
  Stethoscope,
  TriangleAlert,
  "Banknote-x": BanknoteX,
  BanknoteArrowUp,
  House,
  AlarmClock,
  Wallet,
  File,
  Cross,
  CircleX,
  Clock,
  Calendar,
  Briefcase,
  Plane,
  Sun,
  Thermometer,
  Cpu,
  BusFront,
  Ambulance,
  Flame,
  Coffee,
  Music,
  Trophy,
  ReceiptText,
  LayoutDashboard,
  Shapes,
  Leaf,
  Map,
  Heart,
  Camera,
  Handshake,
  HandFist,
  Ban,
};
